<template>
  <div class="modal-content">
    <h1 class="text-center">{{$t('modal-project.modalCustomDeleteTitle')}}</h1>
    <div class="columns">
      <div class="column is-12">
        <p class="text-center">{{$t('modal-project.modalCustomDeleteText')}}</p>
        <p v-if="errorMessage" class="required text-center">{{errorMessage}}</p>
      </div>
    </div>
    <div class="text-center buttons-modal">
      <a @click="handleRemoveProject()" class="button primary">{{$t('tasks.customDeleteOK')}}</a>
      <a @click="closeModal()" class="button">{{$t('global.cancel')}}</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'remove-project-modal',
  props: {
    data: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      errorMessage: null
    }
  },
  methods: {
    ...mapActions({
      removeProject: 'removeProject',
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setModalData: 'setModalData'
    }),
    async handleRemoveProject () {
      this.errorMessage = null
      try {
        await this.removeProject(this.data)
        this.closeModal()
      } catch (err) {
        console.log('error removing project', err)
        this.errorMessage = this.$t('modal-project.modalRemoveError')
      }
    },
    closeModal () {
      this.setShowModal(false)
      this.setModalType(null)
      this.setModalData(null)
    }
  }
}
</script>
